import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max;
  }

  /**
   * Updates button states based on current value and limits
   */
  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    minusButton.disabled = value <= min;
    plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
  }

  /**
   * Sync hidden Shopify quantity when value is changed directly
   */
  setValue(value) {
    super.setValue(value);
    this.syncHiddenQuantity(value);
  }

  /**
   * Sync hidden Shopify quantity when using + or - buttons
   */
  updateQuantity(stepMultiplier) {
    super.updateQuantity(stepMultiplier);

    const { value } = this.getCurrentValues();
    this.syncHiddenQuantity(value);
  }

  /**
   * Sync hidden Shopify quantity when typing manually
   */
  setQuantity(event) {
    super.setQuantity(event);

    const { value } = this.getCurrentValues();
    this.syncHiddenQuantity(value);
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
